import React from "react";
import SwipeToggleDays from "../SwipeToggle/days";
import selectedText from "./selectedText";

export default ({ loading, days = [], hours = [], removeDays, createDays }) => (
  <div className="p-4">
    <h5 className="bold p-2">{selectedText(hours, days)}</h5>
    <SwipeToggleDays
      loading={loading}
      days={days}
      onChange={day => days.includes(day) ? removeDays(day) : createDays(day)}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/DaysSelect/index.js